import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { RouterService } from "src/app/libs/data-access/services/router/router.service";

@Component({
  selector: "tic-not-found",
  templateUrl: "./not-found.component.html",
  styleUrls: ["./not-found.component.scss"],
})
export class NotFoundComponent implements OnInit {
  constructor(private router: Router, private routerService: RouterService) {}

  ngOnInit(): void {
    
  }

  private initializeRouteParamsSubscription(): void {
    this.routerService.scrollToTop();
    setTimeout(() => {
      this.navigateToHomePage();
    }, 3000);
  }

  navigateToHomePage() {
    this.router.navigate(["/home-page"]);
  }
}
